import { OperatorFunction, Observable } from 'rxjs';
import ImageProcessingError from '@/model/ImageProcessingError';
import { filter } from 'rxjs/operators';

export default function noErrors<T>(): OperatorFunction<T, Exclude<T, ImageProcessingError<any>>> {
    return ((source) => source.pipe(
        filter((val) => !(val instanceof ImageProcessingError)),
    )) as OperatorFunction<T, Exclude<T, ImageProcessingError<any>>>;
}
